import {deviceGroupScheduleConstants} from "../constants/device-group-schedule.constants";

const initState = {
    schedule: null,
    scheduleException: null,
};

export function deviceGroupScheduleReducer(state = initState, action) {
    switch (action.type) {
        case deviceGroupScheduleConstants.SCHEDULE_BY_ID_REQUEST:
        case deviceGroupScheduleConstants.SCHEDULE_BY_ID_FAILURE:
        case deviceGroupScheduleConstants.SCHEDULE_BY_ID_CLEAR_STORE:
            return {
                schedule: null,
                scheduleException: null
            };
        case deviceGroupScheduleConstants.SCHEDULE_BY_ID_SUCCESS:
            return {
                schedule: action.scheduleModel?.schedule,
                scheduleException: action.scheduleModel?.scheduleException
            };
        default:
            return state
    }
}
